import { render, staticRenderFns } from "./PortalpageDesigner.vue?vue&type=template&id=93d9be82"
import script from "./PortalpageDesigner.vue?vue&type=script&lang=js"
export * from "./PortalpageDesigner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports